var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavCompetition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Competitions",
    d: "M12.4719 14.1431V16.147H17.3314V18.0908H5.66857V16.147H10.5281V14.1431C6.69265 13.6648 3.72478 10.393 3.72478 6.42807V0.59668H19.2752V6.42807C19.2752 10.393 16.3073 13.6648 12.4719 14.1431ZM0.809082 2.54048H2.75288V6.42807H0.809082V2.54048ZM20.2471 2.54048H22.1909V6.42807H20.2471V2.54048Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCompetition);
export default __webpack_public_path__ + "static/media/nav-competition.13741f18823ba485164ed5b4e094cf3d.svg";
export { ForwardRef as ReactComponent };